export const ContractPartnerStatus = {
    ACCESSIBLE: "ACCESSIBLE",
    LOCKED: "LOCKED",
    CANCELLED: "CANCELLED",
    REMOVED: "REMOVED",
}
